import { ResponseData } from "./tunnel-message-data";

/**
 * @hidden
 */
export interface PromptResponse extends ResponseData {
    type: '@stemcstudio/modal-dialog-service:prompt-response';
    value?: string;
}

/**
 * @hidden
 */
export function isPromptResponse(message: MessageEvent): message is MessageEvent<PromptResponse> {
    const duck = message as MessageEvent<PromptResponse>;
    if (duck.data.type && duck.data.type === '@stemcstudio/modal-dialog-service:prompt-response') {
        return true;
    } else {
        return false;
    }
}
